import React from 'react';
import { Sparkles } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="w-full bg-[#F9FAFB] pt-4 pb-8 px-4 overflow-hidden" data-id="element-97">
      <div className="max-w-md mx-auto flex flex-col items-center text-center" data-id="element-98">
        {/* Badge */}
        <div className="mb-3 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-purple-100 border border-purple-200 shadow-sm" data-id="element-99">
          <Sparkles className="w-3 h-3 text-purple-600" data-id="element-100" />
          <span className="text-[10px] font-bold text-purple-700 tracking-wider uppercase" data-id="element-101">
            MEGA PACK TERAPÉUTICO PARA PSICÓLOGAS™
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-2xl md:text-4xl font-black text-gray-900 leading-tight mb-2" data-id="element-102">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-gray-900 to-gray-700" data-id="element-103">
            6 meses de sesiones organizadas,
          </span>
          <br data-id="element-104" />
          <span className="text-purple-600" data-id="element-105">
            sin improvisar ni planificar desde cero
          </span>
        </h1>

        {/* Subheadline */}
        <p className="text-sm md:text-base text-gray-600 font-medium leading-snug mb-4 max-w-xs mx-auto" data-id="element-106">
          El sistema definitivo de actividades terapéuticas listas para usar en
          consulta. Sin improvisar. Sin llevar trabajo a casa.
        </p>

        {/* Product Image - Optimized for iPhone view */}
        <div className="relative w-full max-w-[280px] md:max-w-sm mb-4" data-id="element-107">
          <div className="absolute inset-0 bg-purple-500/20 blur-2xl rounded-full transform scale-90" data-id="element-108" />
          <img src="https://cdn.magicpatterns.com/uploads/qFcLK6BebzgS8PN7cKbdQW/MOCK_UP_PSICOLOGA-removebg-preview.png" alt="Mega Pack Terapéutico" className="relative z-10 w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-109" />
        </div>

        {/* CTA */}
        <div className="w-full mb-3" data-id="element-110">
          <CTAButton text="SÍ, QUIERO ORDENAR MI PRÁCTICA" subtext="Oferta por tiempo limitado" fullWidth={true} data-id="element-111" />
        </div>

        {/* Social Proof */}
        <div className="flex items-center justify-center gap-2" data-id="element-112">
          <div className="flex -space-x-2" data-id="element-113">
            {[1, 2, 3, 4].map(i => <div key={i} className="w-6 h-6 rounded-full border-2 border-white bg-gray-200 overflow-hidden" data-id="element-114">
                <img src={`https://randomuser.me/api/portraits/women/${20 + i}.jpg`} alt="User" className="w-full h-full object-cover" data-id="element-115" />
              </div>)}
          </div>
          <p className="text-xs font-medium text-gray-600" data-id="element-116">
            Más de{' '}
            <span className="font-bold text-purple-700" data-id="element-117">1,200 psicólogas</span>{' '}
            ya lo usan
          </p>
        </div>
      </div>
    </section>;
}